import { Box, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTER } from '../router/constants'
import { convertToPersianNumber } from '../helpers/convertToPersianNumbers';
import Buttons from '../Components/Buttons';
import { getBankDetail } from '../helpers/getBankDetails';

const Payment = () => {

    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

    const navigate = useNavigate()


    const [cardNumber, setCardNumber] = useState('');
    const [cardError, setCardError] = useState('');
    const [bankInfo, setBankInfo] = React.useState({ name: 'نامشخص', icon: 0, isExportBank: false });
    const [expireMonth, setExpireMonth] = React.useState('');
    const [expireYear, setExpireYear] = React.useState('');
    const [cvv2, setCvv2] = React.useState('');
    const [expireMonthError, setExpireMonthError] = React.useState('');
    const [expireYearError, setExpireYearError] = React.useState('');
    const [cvv2Error, setCvv2Error] = React.useState('');
    const [secondPassword, setSecondPassword] = useState('');
    const [secondPasswordError, setSecondPasswordError] = useState('');




    const handleConfirmSetting = () => {
        navigate(ROUTER.BOOKING_TRACKING)
    }


    let price = '2,800,000'

    const isFormValid =
        secondPassword.length > 3 &&
        cardNumber.length === 16 &&
        expireMonth.length === 2 &&
        expireYear.length === 2 &&
        (cvv2.length === 3 || cvv2.length === 4) &&
        !cardError &&
        !expireMonthError &&
        !expireYearError &&
        !cvv2Error &&
        !secondPasswordError;


    return (
        <div className='container' style={{ padding: isLargeScreen ? '60px 40px' : '30px 20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant={isLargeScreen ? 'h1' : 'h2'} align="center" color='black' sx={{ fontWeight: isLargeScreen ? 600 : 700, color: 'black', mb: '64px' }}>
                پرداخت
            </Typography>
            <Box sx={{ mb: "64px" }}>
                <Typography
                    color={theme.palette.primary.main}
                    variant={isLargeScreen ? 'h2' : 'h3'}
                    align="center"
                    mb={'24px'}
                    fontWeight={700}
                >
                    {convertToPersianNumber(price)} ریال
                </Typography>
                <Box width={'400px'} display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} mx={'auto'}>
                    <form style={{ width: '100%' }}>
                        <Grid mb={'24px'} position={'relative'}>
                            <Grid width="100%" direction="rtl" position="relative" mb={'4px'}>
                                <input
                                    placeholder="شماره کارت"
                                    type="number"
                                    value={cardNumber}
                                    onChange={(e) => {
                                        const value = e.target.value.slice(0, 16); // limit to 16 digits
                                        setCardNumber(value);
                                        if (value.length >= 6) {
                                            setBankInfo(getBankDetail(value));
                                        } else {
                                            setBankInfo({ name: 'نامشخص', icon: 0, isExportBank: false });
                                        }
                                    }}
                                    onBlur={() => {
                                        if (cardNumber.length !== 16) {
                                            setCardError('شماره کارت باید ۱۶ رقم باشد');
                                        } else {
                                            setCardError('');
                                        }
                                    }}
                                    style={{
                                        padding: '16px 16px 16px 48px',
                                        height: '48px',
                                        width: '100%',
                                        border: cardError ? '1px solid #D50D0D' : '1px solid #6069E7',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                        direction: 'ltr',
                                        textAlign: 'left',
                                    }}
                                    className="card-input"
                                />

                                {/* Bank Icon */}
                                {bankInfo.icon !== 0 && (
                                    <img
                                        src={`./assets/image/bank/${bankInfo.icon}.png`} // adjust path as needed
                                        alt={bankInfo.name}
                                        style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', height: '24px' }}
                                    />
                                )}

                            </Grid>
                            {cardError && (
                                <Typography variant="subtitle2" fontWeight={700} color={theme.palette.secondary.main} mt={'4px'} display="block" style={{ position: 'absolute', right: 0, top: '46px' }}>
                                    {cardError}
                                </Typography>
                            )}
                        </Grid>
                        <Grid display={'flex'} alignItems={'center'} gap={'12px'} mb={'24px'}>
                            <Grid width={'50%'} display={'flex'} alignItems={'center'} gap={'12px'}>
                                <Grid width={'50%'} position={'relative'}>
                                    <input
                                        className="card-input"
                                        placeholder="ماه"
                                        type="number"
                                        value={expireMonth}
                                        onChange={(e) => {
                                            const val = e.target.value.slice(0, 2);
                                            setExpireMonth(val);
                                        }}
                                        onBlur={() => {
                                            if (expireMonth.length !== 2) {
                                                setExpireMonthError('ماه باید ۲ رقم باشد');
                                            } else {
                                                setExpireMonthError('');
                                            }
                                        }}
                                        style={{
                                            padding: '16px',
                                            height: '48px',
                                            width: '100%',
                                            border: cardError ? '1px solid #D50D0D' : '1px solid #6069E7',
                                            borderRadius: '8px',
                                            fontSize: '16px',
                                            direction: 'ltr',
                                            textAlign: 'left',
                                        }}
                                    />
                                    {expireMonthError && (
                                        <Typography variant="subtitle2" fontWeight={700} color={theme.palette.secondary.main} mt="4px" display="block" style={{ position: 'absolute', right: 0, top: '46px' }}>
                                            {expireMonthError}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid width={'50%'} position={'relative'}>
                                    <input
                                        className="card-input"
                                        placeholder="سال"
                                        type="number"
                                        value={expireYear}
                                        onChange={(e) => {
                                            const val = e.target.value.slice(0, 2);
                                            setExpireYear(val);
                                        }}
                                        onBlur={() => {
                                            if (expireYear.length !== 2) {
                                                setExpireYearError('سال باید ۲ رقم باشد');
                                            } else {
                                                setExpireYearError('');
                                            }
                                        }}
                                        style={{
                                            padding: '16px',
                                            height: '48px',
                                            width: '100%',
                                            border: cardError ? '1px solid #D50D0D' : '1px solid #6069E7',
                                            borderRadius: '8px',
                                            fontSize: '16px',
                                            direction: 'ltr',
                                            textAlign: 'left',
                                        }}
                                    />
                                    {expireYearError && (
                                        <Typography variant="subtitle2" fontWeight={700} color={theme.palette.secondary.main} mt="4px" display="block" style={{ position: 'absolute', right: 0, top: '46px' }}>
                                            {expireYearError}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid width={'50%'} position={'relative'}>
                                <input
                                    className="card-input"
                                    type="number"
                                    placeholder="CVV2"
                                    value={cvv2}
                                    onChange={(e) => {
                                        const val = e.target.value.slice(0, 4); // limit to 4
                                        setCvv2(val);
                                    }}
                                    onBlur={() => {
                                        if (cvv2.length < 3 || cvv2.length > 4) {
                                            setCvv2Error('کد CVV2 باید ۳ یا ۴ رقم باشد');
                                        } else {
                                            setCvv2Error('');
                                        }
                                    }}
                                    style={{
                                        padding: '16px',
                                        height: '48px',
                                        width: '100%',
                                        borderRadius: '8px',
                                        border: cardError ? '1px solid #D50D0D' : '1px solid #6069E7',
                                        fontSize: '16px',
                                        direction: 'ltr',
                                        textAlign: 'left',
                                    }}
                                />
                                {cvv2Error && (
                                    <Typography variant="subtitle2" fontWeight={700} color={theme.palette.secondary.main} mt={'4px'} display="block" style={{ position: 'absolute', right: 0, top: '46px' }}>
                                        {cvv2Error}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        <Grid position={'relative'}>
                            <input
                                placeholder="رمز دوم"
                                type="number"
                                value={secondPassword}
                                onChange={(e) => {
                                    const val = e.target.value.slice(0, 12); // usually 4-12 digits, limit if needed
                                    setSecondPassword(val);
                                }}
                                onBlur={() => {
                                    if (secondPassword.length < 4) {
                                        setSecondPasswordError('رمز دوم باید حداقل ۴ رقم باشد');
                                    } else {
                                        setSecondPasswordError('');
                                    }
                                }}
                                style={{
                                    padding: '16px',
                                    height: '48px',
                                    width: '100%',
                                    border: secondPasswordError ? '1px solid #D50D0D' : '1px solid #6069E7',
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    direction: 'ltr',
                                    textAlign: 'left',
                                }}
                                className="card-input"
                            />
                            {secondPasswordError && (
                                <Typography
                                    variant="subtitle2"
                                    fontWeight={700}
                                    color={theme.palette.secondary.main}
                                    mt={'4px'}
                                    display="block"
                                    style={{ position: 'absolute', right: 0 }}
                                >
                                    {secondPasswordError}
                                </Typography>
                            )}

                        </Grid>
                    </form>
                </Box>
            </Box>
            <Buttons isDisabled={!isFormValid} backTitle={'بازگشت'} checkTitle={'پرداخت'} backLink={ROUTER.SYSTEMS} checkLink={ROUTER.BOOKING_TRACKING} onCheck={handleConfirmSetting} />
        </div>
    )
}

export default Payment
